import * as React from 'react'
import { DisplayContent } from 'react-content-engine'
import { connect } from 'react-redux'

import { ListItem } from 'components/List'
import AirportSummary from './shared/AirportSummary'
import DaysSummary from './shared/DaysSummary'
import DepartureDate from './shared/DepartureDate'
import ExcludedCitiesSummary from './shared/ExcludedCitiesSummary'
import NoteSummary from './shared/NoteSummary'
import NrPeopleSummary from './shared/NrPeopleSummary'

import { FunnelOrder } from '../../data/models/funnelOrder'
import { getRoomType, roomType } from '../../data/models/funnelOrder/roomType'
import { getDestination } from '../../data/models/funnelOrder/summary'
import { AppState } from '../../data/state'
import TimesSummary from './shared/TimesSummary'

interface FlySummaryProps {
  funnelOrder: FunnelOrder
  loading: boolean
  final?: boolean
  fixedParams?: string[]
}

const FlySummary: React.FC<FlySummaryProps> = ({
  funnelOrder,
  loading,
  fixedParams,
}) => {
  const loadingClass = loading ? 'is-loading' : ''
  const isTimeSummaryBold = fixedParams
    ? fixedParams.includes(`incomingTime`) ||
      fixedParams.includes(`outgoingTime`)
    : false

  return (
    <>
      <NrPeopleSummary />
      <DepartureDate />
      <DaysSummary
        contentKey="citytrip-summary"
        getDestination={getDestination}
        destination={funnelOrder.destination}
      />
      <ExcludedCitiesSummary />
      <AirportSummary />
      <TimesSummary bold={isTimeSummaryBold} />
      <ListItem>
        <span className={loadingClass}>
          {getRoomType(funnelOrder.roomType)}&nbsp;
          {funnelOrder.roomType === roomType.premium ? (
            <DisplayContent contentKey="premium-accomodation-summary">
              hotel
            </DisplayContent>
          ) : (
            <DisplayContent contentKey="accomodation-summary">
              accomodation
            </DisplayContent>
          )}
        </span>
      </ListItem>
      <NoteSummary />
    </>
  )
}

export default connect((state: AppState) => ({
  funnelOrder: state.funnelOrder,
  loading: state.contentEngine.loading,
}))(FlySummary)
